import BaseService from './BaseService'

const ApiService = {
    fetchData(param) {
        return BaseService(param)
    }
}

export default ApiService
